import { CS } from "../../../base/utils/styler";

export const baseStyle: CS =
{
    fontSize: '2em',
    fontWeight: 'bold',
    margin: '16px 0 24px 0',
    textAlign: 'center'
}   